import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import useElakaySwiper from "../../slider/swiperSettings/useElakaySwiper";
import "swiper/css";
import "swiper/css/navigation";
import ProviderProductCard from "../components/ProviderProductCard";
import "./ui.css";

// Same Swiper setup/breakpoints as the Buyer product sliders (swiperProduct.js: 2/3/4/4/5 per view).
// swiperProduct itself hard-codes the Buyer <Card> (cart button, /product/preview links), so the
// slider shell is mirrored here and fed Provider cards.
// Options: instance swiperOptions > Animation Settings -> Swiper Settings ("Provider Product Carousel") > origin.
const CAROUSEL_TABLE = { 0: { slidesPerView: 2, spaceBetween: 12 }, 640: { slidesPerView: 3, spaceBetween: 12 }, 768: { slidesPerView: 4, spaceBetween: 12 }, 1200: { slidesPerView: 5, spaceBetween: 12 } };

export default function ProductCarousel({ title, subtitle, products = [], seeAllTo, seeAllLabel, swiperOptions }) {
  const swp = useElakaySwiper("providerCarousel", { swiperOptions, legacyTable: CAROUSEL_TABLE, slideCount: products.length });
  if (!products.length) return null;
  return (
    <section className="pcar">
      <header className="pcar__head">
        <div><h2>{title}</h2>{subtitle && <p>{subtitle}</p>}</div>
        {seeAllTo && <Link to={seeAllTo}>{seeAllLabel}</Link>}
      </header>
      <Swiper key={swp.key} {...swp.swiperProps} className={swp.className} style={swp.style}>
        {products.map((p) => <SwiperSlide key={p._id}><ProviderProductCard product={p} variant="browse" /></SwiperSlide>)}
      </Swiper>
    </section>
  );
}
